import React from 'react';

export function IconCheck() {
  return (
    <svg width="16" height="17" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <path
          d="M12.633 0L14 1.333 5.116 10l-.225-.22-.107.106L0 5.219l1.367-1.333 3.641 3.551L12.633 0z"
          id="check_svg__a"
        />
      </defs>
      <g transform="translate(1 3.204)" fill="none" fillRule="evenodd">
        <mask id="check_svg__b" fill="#fff">
          <use xlinkHref="#check_svg__a" />
        </mask>
        <use fill="#286EFA" xlinkHref="#check_svg__a" />
        <path fill="#286EFA" mask="url(#check_svg__b)" d="M-6-7h25v25H-6z" />
      </g>
    </svg>
  );
}
